export const FETCH_CONSOLE_CONFIGURATION = 'configuration/console/FETCH'
export const FETCH_CONSOLE_CONFIGURATION_SUCCESS = `${FETCH_CONSOLE_CONFIGURATION}_SUCCESS`

export const FETCH_TENANT_CONFIGURATION = 'configuration/tenant/FETCH'
export const FETCH_TENANT_CONFIGURATION_SUCCESS = `${FETCH_TENANT_CONFIGURATION}_SUCCESS`

export const FETCH_CONTEXT_ORGANIZATION = 'context/organization/FETCH'
export const FETCH_CONTEXT_ORGANIZATION_SUCCESS = `${FETCH_CONTEXT_ORGANIZATION}_SUCCESS`

export const FETCH_CONTEXT_USER = 'context/user/FETCH'
export const FETCH_CONTEXT_USER_SUCCESS = `${FETCH_CONTEXT_USER}_SUCCESS`

export const FETCH_ROLES = 'organization/roles/FETCH'
export const FETCH_ROLES_SUCCESS = `${FETCH_ROLES}_SUCCESS`

export const LOAD_REDUX_STATE = 'redux/LOAD'
export const SAVE_REDUX_STATE = 'redux/SAVE'
